module.exports = __webpack_public_path__ + "img/img_point_check_74174d1e6.png";